import {
  Box,
  Button,
  Container,
  FormLabel,
  Text,
  useDisclosure,
  useOutsideClick,
} from "@chakra-ui/react";
import FixedBar from "components/ui/FixedBar";
import SearchBar from "components/ui/SearchBar";
import { useSearchContext } from "contexts/SearchContext";
import CustomCheckBox from "features/companies/components/CustomCheckBox";
import { useRef } from "react";
import { useFormContext } from "react-hook-form";

export default function SearchResultMembers() {
  const ref = useRef();
  const { data: searchRecipients, query, setQuery } = useSearchContext();
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const { watch, setValue } = useFormContext();
  useOutsideClick({
    ref,
    handler: onClose,
  });

  const recipients = watch("recipients");

  const hasResults: boolean = !!searchRecipients && searchRecipients.length > 0;
  const isVisible: boolean = query.trim().length > 0 && isOpen;

  return (
    <Box w="full" ref={ref}>
      <Box>
        <FormLabel>Selecionar pela busca</FormLabel>
        <SearchBar
          placeholder="Digite para buscar por nome, email ou empresa "
          inputProps={{
            onFocus: onOpen,
          }}
          mb={0}
        />
      </Box>

      <Box
        display={isVisible ? "flex" : "none"}
        w="full"
        pos="absolute"
        top="61px"
        bg="white"
        boxShadow="0px 24px 56px -4px rgba(88, 92, 95, 0.10)"
        pb={hasResults ? "100px" : "10px"}
        zIndex={1}
      >
        {!hasResults && (
          <Container>
            <Text>Nenhum resultado encontrado</Text>
          </Container>
        )}
        {hasResults && (
          <Box maxH="400px" overflowY="auto" px="30px">
            {searchRecipients &&
              searchRecipients.map((recipient) => (
                <CustomCheckBox
                  py="13px"
                  key={`recipient-${recipient.id}`}
                  image={recipient.company.logo}
                  value={recipient.id}
                  isChecked={recipients.includes(recipient.id)}
                  label={`${recipient.name} - ${recipient.company.name}`}
                  description={`${recipient.email}`}
                  onChange={(e) => {
                    const newItems = e.target.checked
                      ? [...recipients, e.target.value]
                      : [
                          ...recipients.filter(
                            (item) => item !== e.target.value
                          ),
                        ];
                    setValue("recipients", newItems, { shouldValidate: true });
                  }}
                />
              ))}

            <FixedBar pos="absolute">
              <Button
                variant="primary"
                ml="auto"
                onClick={() => {
                  setQuery("");
                  onClose();
                }}
              >
                Confirmar
              </Button>
            </FixedBar>
          </Box>
        )}
      </Box>
    </Box>
  );
}
